// extracted by mini-css-extract-plugin
export default {"meal":"MealItem_meal__sSe2t","description":"MealItem_description__OEOd1","price":"MealItem_price__3BWT0"};